<div class="col-md-12 pb-3">
  <table class="table m-0">
      <thead class="thead-light">
          <tr>
              <th>Étape</th>
              <th class="text-center">Nombre</th>
              <th class="text-center">Pourcentages</th>
          </tr>
      </thead>
      <tbody>
          <ng-container *ngFor="let ligne of suivi">
              <tr>
                  <td class="text-left" style="width: 50%">
                      {{ ligne.etape }}
                      <mat-icon *ngIf="ligne.ventilation !== null" (click)="expandedElement = expandedElement === ligne ? null : ligne">{{expandedElement === ligne ? 'expand_less' : 'expand_more'}}</mat-icon>
                  </td>
                  <td class="text-center" style="width: 25%"><button type="button" class="btn btn-link" (click)="suiviQuestionnaire(ligne.filtreEtape, ligne.filtreNiveauErreur)">{{ ligne.nombre }}</button></td>
                  <td class="text-center" style="width: 25%">{{ ligne.pourcentage }}</td>
              </tr>
              <tr *ngFor="let ventilation of expandedElement === ligne ? ligne.ventilation : null">
                  <td class="text-center" style="width: 50%"><em>{{ ventilation.etape }}</em>
                  </td>
                  <td class="text-center" style="width: 25%"><button type="button" class="btn btn-link" (click)="suiviQuestionnaire(ventilation.filtreEtape, ventilation.filtreNiveauErreur)">{{ ventilation.nombre }}</button>
                  </td>
                  <td class="text-center" style="width: 25%">{{ ventilation.pourcentage }}
                  </td>
              </tr>
          </ng-container>
          <tr>
              <th class="text-left" style="width: 50%">Total
              </th>
              <th class="text-center" style="width: 25%"><button type="button" class="btn btn-link" (click)="suiviQuestionnaire(null, null)">{{ this.somme }}</button>
              </th>
              <th class="text-center" style="width: 25%">100%
              </th>
          </tr>
      </tbody>
  </table>
</div>
